/** Typography & layout primitives — NVL design language. */
import { cn } from "../../lib/cn";

export function Container({ className, ...props }) {
  return <div className={cn("nvl-container", className)} {...props} />;
}

export function Section({ className, padded = "default", ...props }) {
  const pads = { default: "sec-pad", sm: "sec-pad-sm", none: "" };
  return <section className={cn("relative z-[1]", pads[padded], className)} {...props} />;
}

export function Eyebrow({ className, centered = false, children, ...props }) {
  return (
    <span className={cn("eyebrow", centered && "justify-center", className)} {...props}>
      {children}
    </span>
  );
}

export function DisplayHeading({ className, children, as: As = "h1", ...props }) {
  return (
    <As
      className={cn(
        "font-display font-medium leading-[1.02] tracking-[-0.01em]",
        "text-[clamp(40px,6.5vw,84px)]",
        className
      )}
      {...props}
    >
      {children}
    </As>
  );
}

export function SectionTitle({ className, children, as: As = "h2", ...props }) {
  return (
    <As
      className={cn(
        "font-display font-medium leading-[1.05] tracking-[-0.01em]",
        "text-[clamp(32px,4.2vw,54px)]",
        className
      )}
      {...props}
    >
      {children}
    </As>
  );
}

export function Lede({ className, children, ...props }) {
  return (
    <p
      className={cn(
        "text-text-dim font-normal max-w-[56ch] text-[clamp(15px,1.3vw,18px)] leading-relaxed",
        className
      )}
      {...props}
    >
      {children}
    </p>
  );
}

export function AccentItalic({ children, className, ...props }) {
  return (
    <span className={cn("italic text-mauve", className)} {...props}>
      {children}
    </span>
  );
}

export function PageHeader({ eyebrow, title, lede, actions, align = "left", className }) {
  return (
    <header
      className={cn(
        "flex flex-col gap-5 mb-12",
        align === "center" && "items-center text-center",
        className
      )}
      data-testid="page-header"
    >
      {eyebrow && <Eyebrow centered={align === "center"}>{eyebrow}</Eyebrow>}
      {title && <SectionTitle as="h1" className="mt-2">{title}</SectionTitle>}
      {lede && <Lede className={align === "center" ? "mx-auto" : ""}>{lede}</Lede>}
      {actions && <div className="mt-2 flex flex-wrap gap-3">{actions}</div>}
    </header>
  );
}
